// extracted by mini-css-extract-plugin
export var avatarContainer = "_a8-0";
export var avatarTypingWave = "_a8-i";
export var gray = "_a8-f";
export var green = "_a8-c";
export var icon = "_a8-9";
export var image = "_a8-1";
export var lg = "_a8-6";
export var md = "_a8-5";
export var presenceDot = "_a8-b";
export var red = "_a8-d";
export var sm = "_a8-4";
export var status = "_a8-a";
export var typingDot = "_a8-h";
export var typingPill = "_a8-g";
export var xl = "_a8-7";
export var xs = "_a8-3";
export var xxl = "_a8-8";
export var xxs = "_a8-2";
export var yellow = "_a8-e";